import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "peptichill_cookie_consent";

export default function CookieBanner() {
  const [open, setOpen] = useState(() => {
    if (typeof window === "undefined") return false;
    try {
      return !window.localStorage.getItem(STORAGE_KEY);
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try {
      if (!window.localStorage.getItem(STORAGE_KEY)) setOpen(true);
    } catch {
      /* no-op */
    }
  }, []);

  const setChoice = (value) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* no-op */
    }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3 sm:px-6 sm:pb-6 animate-slide-up"
      data-testid="cookie-banner"
    >
      <div
        className="mx-auto max-w-[1100px] rounded-2xl bg-white border border-silver/60 shadow-card p-5 sm:p-6 flex flex-col gap-4 md:flex-row md:items-center md:gap-6 max-h-[40svh] overflow-y-auto"
      >
        <div className="flex-1 text-sm leading-relaxed text-ink">
          <strong className="text-navy font-semibold block mb-1">Cookies on PeptiChill</strong>
          We use essential cookies to make this site work, and optional analytics cookies to
          understand how it&rsquo;s used. You can change this any time.{" "}
          <Link
            to="/privacy"
            className="inline-block py-1 text-navy underline underline-offset-4 hover:text-cyan transition-colors"
          >
            Privacy policy
          </Link>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 shrink-0">
          <button
            type="button"
            onClick={() => setChoice("essential")}
            className="h-12 sm:h-11 rounded-full border border-navy text-navy px-5 text-sm font-medium hover:bg-ice transition-colors w-full sm:w-auto"
            data-testid="cookie-essential-button"
          >
            Essential only
          </button>
          <button
            type="button"
            onClick={() => setChoice("all")}
            className="h-12 sm:h-11 rounded-full bg-navy text-white px-5 text-sm font-semibold hover:brightness-110 transition w-full sm:w-auto"
            data-testid="cookie-accept-all-button"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
